// extracted by mini-css-extract-plugin
module.exports = {"groupList":"gKyHpBpmJf3g-p-0j+NWlg==","groupName":"_7CCrFaTUiYXXNl5eMWiZGw=="};